module.exports = __webpack_public_path__ + "63fcc6d14e247635b0c4f615b0b823ad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-blue.png
// module id = 2458
// module chunks = 0